import { RootState } from 'lib/stores';

export const listViewStateSelector = (state: RootState) =>
  state.appInfo.isListView;

export const selectedMenuKeysSelector = (state: RootState) =>
  state.appInfo.selectedMenuKeys;

export const selectedOpenKeysSelector = (state: RootState) =>
  state.appInfo.selectedOpenKeys;

export const appPrimaryColorSelector = (state: RootState) =>
  state.appInfo.appPrimaryColor;

export const darkModeSelector = (state: RootState) => state.appInfo.darkMode;
